export const Response = {
    ok: 200,
    created: 201,
    accepted: 202,
    noContent: 204,
    movedPermanently: 301,
    movedTemporary: 302,
    badRequest: 400,
    unauthorized: 401,
    notFound: 404,
    expectedError: 475,
    internalServerError: 500,
    serviceUnavailable: 503,
};
